<template>
  <component
    :is="elementType"
    v-bind="computedAttrs"
    :class="['vehicle-selector-action', { 'vehicle-selector-action--root': isRootNode }, { 'vehicle-selector-action--is-selected': context.isSelected(node.code) }]"
    @click="handleClick"
    @keydown.enter="handleClick">
    <input
      v-if="!isLink"
      :id="id"
      type="radio"
      :name="name"
      :checked="context.isSelected(node.code)"
      class="vehicle-selector-action__input"
      @click.prevent.stop>
    <oie-use-svg v-if="isRootNode && node.codeNameIcon" class="vehicle-selector-action__custom-icon" :svg="node.codeNameIcon"></oie-use-svg>
    {{ node.name }}
    <oie-base-icon v-if="isLink && !isRootNode" icon="chevron-right" size="m"></oie-base-icon>
    <oie-base-icon v-else-if="context.isSelected(node.code)" icon="checkmark-outline" size="s"></oie-base-icon>
  </component>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api'
import _ from 'lodash'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true
    },
    level: {
      type: String,
      default: '0'
    },
    node: {
      type: Object,
      required: true
    },
    isLink: {
      type: Boolean,
      default: false
    },
    isRootNode: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { attrs, emit }) {
    const id = _.uniqueId('vehicle-selector-action-')
    const name = props.context.nodeData.value[props.level].node.code

    const elementType = computed(() => {
      return props.isLink ? 'a' : 'label'
    })

    const computedAttrs = computed(() => {
      return {
        attrs,
        for: props.isLink ? undefined : id,
        href: props.isLink ? props.node.url : undefined
      }
    })

    function handleClick(event) {
      if (!props.isLink) {
        emit('click')
      }
    }

    return {
      id,
      name,
      elementType,
      computedAttrs,
      handleClick
    }
  }
})
</script>

<style lang="scss">
/*------------------------------------*\
   BASE
\*------------------------------------*/
.vehicle-selector-action {
  @include reset-button;
  position: relative;
  text-decoration: none;
  padding: 7px 10px;
  background-color: #eff6fb;
  border: 1px solid #bbdff4;
  height: 100%;
}

.vehicle-selector-action:hover,
.vehicle-selector-action:focus,
.vehicle-selector-action:focus-visible,
.vehicle-selector-action:focus-within {
  background-color: color(background-blue-4);
}

.vehicle-selector-action__input {
  cursor: pointer;
  position: absolute;
  right: 13px;
  height: 20px;
  width: 20px;
  opacity: 0;
  z-index: -1;

}

/*------------------------------------*\
   STATE
\*------------------------------------*/

.vehicle-selector-action--root {
  color: color(brand-blue-3);
  border: 1px solid color(brand-blue-3);
  background-color: white;
  border-radius: .1875rem;
}

.vehicle-selector-action--is-selected {
  background-color: #dfebf3;
  border-color: color(brand-blue-3);
}

/*------------------------------------*\
   ICON
\*------------------------------------*/
.vehicle-selector-action__custom-icon {
  height: 25px;
  width: auto;
}

.vehicle-selector-action .base-icon {
  margin-left: auto;
}
</style>
